import JustValidate from 'just-validate';

// Styling fixes form

document.addEventListener("DOMContentLoaded", function() {
    const radioButtons = document.querySelectorAll('.umbraco-forms-form .radiobuttonlist input[type="radio"]');
    const checkBoxes = document.querySelectorAll('.umbraco-forms-form input[type="checkbox"]');
    const fieldsets = document.querySelectorAll('.umbraco-forms-fieldset');
    const fields = document.querySelectorAll('.umbraco-forms-field');
    const captions = document.querySelectorAll('.umbraco-forms-caption');
    const infotextFields = document.querySelectorAll('.titleanddescription');

    if (radioButtons) {
        for (let index = 0; index < radioButtons.length; index++) {
            const element = radioButtons[index];
            if (element) {
                element.setAttribute('style', 'width: 1.75rem !important; height: 1.75rem !important; border: 1px solid #c8c6c4 !important; display: inline-block !important');
            }
        }
    }

    if (checkBoxes) {
        for (let index = 0; index < checkBoxes.length; index++) {
            const element = checkBoxes[index];
            if (element) {
                element.setAttribute('style', 'width: 1.75rem !important; height: 1.75rem !important; border: 1px solid #c8c6c4 !important; display: inline-block !important');
            }
        }
    }
    
    if (fields) {
        for (let index = 0; index < fields.length; index++) {
            const element = fields[index];
            if (element) {
                element.setAttribute('style', 'padding: 0 !important; margin: 0 !important; border: 0 !important;');
            }
        }
    }
    
    if (fieldsets) {
        for (let index = 0; index < fieldsets.length; index++) {
            const element = fieldsets[index];
            if (element) {
                element.setAttribute('style', 'padding-top: 0 !important; margin: 0 !important; border: 0 !important;');
            }
        }
    }
    
    if (captions) {
        for (let index = 0; index < captions.length; index++) {
            const element = captions[index];
            if (element) {
                element.setAttribute('style', 'font-size: 1.75rem !important; line-height: 2.0625rem !important;');
            }
        }
    }

    if (infotextFields) {
        for (let index = 0; index < infotextFields.length; index++) {
            const element = infotextFields[index];
            
            if (element) {
                const legend = element.nextElementSibling.querySelector('legend');

                if (legend) {
                    legend.classList.add('visually-hidden');
                } else {
                    const label = element.nextElementSibling.querySelector('label');

                    if (label) {
                        label.classList.add('visually-hidden');
                    }
                }
            }
        }
    }
});

// Basic functions
function pad(n) {
    return (n.length < 2) ? ("0" + n) : n;
}

// Update RelationData
const streetInputProfileEdit = document.querySelector('#ckStreet input');
const cityInputProfileEdit = document.querySelector('#ckCity input');
const zipCodeInputProfileEdit = document.querySelector('#ckZip input');
const houseNrInputProfileEdit = document.querySelector('#ckHouseNo input');
const houseNoAddInputProfileEdit = document.querySelector('#ckHousNoAdd input');
const phoneInputProfileEdit = document.querySelector('#ckTel');
const mobileInputProfileEdit = document.querySelector('#ckMob');
const birthDateDay = document.querySelector('#ckDoBD');
const birthDateMonth = document.querySelector('#ckDoBM');
const birthDateYear = document.querySelector('#ckDoBY');
const partnerBirthDateDay = document.querySelector('#ckPDoBD');
const partnerBirthDateMonth = document.querySelector('#ckPDoBM');
const partnerBirthDateYear = document.querySelector('#ckPDoBY');

if (document.getElementById('ckProfileForm')) {

    const form = new JustValidate('#ckProfileForm', {
        validateBeforeSubmitting: true
    });
    
    if (form) {
        form
        .addField('#ckInitials', [
            {                
                rule: 'required',
                errorMessage: 'De voorletters zijn verplicht'
            }
        ])
        .addField('#ckBName', [
            {                
                rule: 'required',
                errorMessage: 'De achternaam is verplicht'
            }
        ])
        .addField('#ckIBAN', [
            {
                rule: 'maxLength',
                value: 18,
                errorMessage: 'De lengte van het IBAN nummer is te lang'
            },
            {
                rule: 'customRegexp',
                value: 'NL[a-zA-Z0-9]{2}\s?([a-zA-Z]{4}\s?){1}([0-9]{4}\s?){2}([0-9]{2})\s?',
                errorMessage: 'De ingevulde waarde voor het IBAN nummer is incorrect'
            }
        ])
        .addField('#ckMob', [
            {
                rule: 'custom',
                validator: (value) => {
                  const phone = document.querySelector('#ckTel').value.trim();
                  return value.trim() !== '' || phone !== '';
                },
                errorMessage: 'Telefoonnummer of mobiele nummer is verplicht'
            },
            {
                rule: 'maxLength',
                value: 10,
                errorMessage: 'De lengte van het mobiele telefoonnummer is te lang'
            },
            {
                rule: 'customRegexp',
                value: '06[0-9]{8}',
                errorMessage: 'De ingevulde waarde voor het mobiele telefoonnummer is incorrect'
            }
        ])
        .addField('#ckTel', [
            {                
                rule: 'custom',
                validator: (value) => {
                  const mobile = document.querySelector('#ckMob').value.trim();
                  return value.trim() !== '' || mobile !== '';
                },
                errorMessage: 'Telefoonnummer of mobiele nummer is verplicht'
            },
            {
                rule: 'customRegexp',
                value: '[0-9]',
                errorMessage: 'De ingevulde waarde voor het telefoonnummer is incorrect'
            }
        ])
        .addField('#ckHouseNo', [
            {
                rule: 'customRegexp',
                value: '[0-9]',
                errorMessage: 'De ingevulde waarde voor het huisnummer is incorrect'
            }
        ])        
        .addField('#ckDoBD', [
            {
                validator: () => {
                    const day = document.querySelector('#ckDoBD')?.value;
                    const month = document.querySelector('#ckDoBM')?.value;
                    const year = document.querySelector('#ckDoBY')?.value;

                    if (day && month && year) {
                        birthDateDay.dataset.completed = 'true';
                    }
                    const hasBeenCompleted = birthDateDay.dataset.completed === 'true';

                    if (hasBeenCompleted && (!day || !month || !year)) return false;

                    if (!day || !month || !year) return true;

                    return isValidDate(day, month, year);
                },
                errorMessage: 'De ingevulde geboortedatum is ongeldig',
            },
            {
                rule: 'required',
                errorMessage: 'De geboortedatum is verplicht'
            }
        ])        
        .addField('#ckPDoBD', [
            {
                validator: () => {                    
                    const day = document.querySelector('#ckPDoBD')?.value;
                    const month = document.querySelector('#ckPDoBM')?.value;
                    const year = document.querySelector('#ckPDoBY')?.value;       

                    // date of birth for partner is optional
                    if(!day && !month && !year) return true;

                    if (day && month && year) {
                        partnerBirthDateDay.dataset.completed = 'true';
                    }
                    const hasBeenCompleted = partnerBirthDateDay.dataset.completed === 'true';

                    if (hasBeenCompleted && (!day || !month || !year)) return false;

                    if (!day || !month || !year) return true;

                    return isValidDate(day, month, year);
                },
                errorMessage: 'De ingevulde geboortedatum is ongeldig',
            }
        ])                  
        .addField('#ckZip', [
            {
                rule: 'required',
                errorMessage: 'De postcode is verplicht'
            },
            {
                rule: 'customRegexp',
                value: '^[1-9][0-9]{3}[A-Za-z]{2}$',
                errorMessage: 'Vul uw postcode in zonder spaties, bijvoorbeeld 3100AX. Let op: plaats ook geen spatie vóór de postcode.'
            }
        ])       
        .addField('#ckAgreeToPrivacy', [{
            rule: 'required',
            errorMessage: 'U dient akkoord te gaan met de privacyverklaring'
        }])
        .onSuccess(( event ) => {
            const submitButtonText = document.getElementById('btntext');
            if (submitButtonText) {
                const loader = document.getElementById('btnloader');

                if (loader){
                    const submitButton = document.getElementById('submitProfileEdit');
                    submitButton.setAttribute('disabled',true); 
                    loader.classList.remove('d-none');
                    submitButtonText.innerText = 'Even geduld...';
                }
            }
            UpdateRelationData();
        });

        if (streetInputProfileEdit && cityInputProfileEdit) {
            checkZipCodeProfileEdit();
            zipCodeInputProfileEdit.addEventListener("keyup", checkZipCodeProfileEdit);
            houseNrInputProfileEdit.addEventListener("keyup", checkZipCodeProfileEdit);
            houseNoAddInputProfileEdit.addEventListener("keyup", checkZipCodeProfileEdit)
        }
        
        if(phoneInputProfileEdit && mobileInputProfileEdit) {
            phoneInputProfileEdit.addEventListener("input", () => form.revalidateField('#ckMob'));
            mobileInputProfileEdit.addEventListener("input", () => form.revalidateField('#ckTel'));
        }      
        
        if(birthDateDay && birthDateMonth && birthDateYear) {            
            birthDateDay.addEventListener("input", () => form.revalidateField('#ckDoBD'));
            birthDateMonth.addEventListener("input", () => form.revalidateField('#ckDoBD'));
            birthDateYear.addEventListener("input", () => form.revalidateField('#ckDoBD'));
        }

        if(partnerBirthDateDay && partnerBirthDateMonth && partnerBirthDateYear) {            
            partnerBirthDateDay.addEventListener("input", () => form.revalidateField('#ckPDoBD'));
            partnerBirthDateMonth.addEventListener("input", () => form.revalidateField('#ckPDoBD'));
            partnerBirthDateYear.addEventListener("input", () => form.revalidateField('#ckPDoBD'));
        }
    }
}

function isValidDate(day, month, year) {
    const dayNum = Number.parseInt(day);
    const monthNum = Number.parseInt(month);
    const yearNum = Number.parseInt(year);

    if (Number.isNaN(dayNum) || Number.isNaN(monthNum) || Number.isNaN(yearNum)) {
        return false;
    }

    if (dayNum < 1 || dayNum > 31 || monthNum < 1 || monthNum > 12 || yearNum < 1900 || yearNum > new Date().getFullYear()) {
        return false;
    }

    const dateStr = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    const dateObj = new Date(dateStr);

    // Check of het een geldige datum is en exact overeenkomt met input
    return (
        dateObj &&
        dateObj.getFullYear() === parseInt(year) &&
        dateObj.getMonth() + 1 === parseInt(month) &&
        dateObj.getDate() === parseInt(day)
    );
}

function checkZipCodeProfileEdit() {
    const zipCode = zipCodeInputProfileEdit.value;
    const houseNr = houseNrInputProfileEdit.value;
    const houseNoAdd = houseNoAddInputProfileEdit.value;

    if (zipCode && houseNr) {
        if (zipCode.match(new RegExp(/^[1-9][0-9]{3}[A-Za-z]{2}$/))) {
            clearTimeout(timeout);
            timeout = setTimeout(function () {

                let url = "/umbraco/api/korenFrontend/ZipCodeLookup"
                const zipcodeArg = "zipcode=" + zipCode;
                const housenumberArg = "housenumber=" + houseNr;
                url += "?" + zipcodeArg + "&" + housenumberArg;
                if (houseNoAdd) {
                    url += "&" + "housenumberAddition=" + houseNoAdd;
                }

                fetch(url).then(res =>
                    res.json()).then(d => {
                        if (d) {
                            streetInputProfileEdit.value = d.straatnaam;
                            cityInputProfileEdit.value = d.plaatsnaam;
                        }
                        else {
                            streetInputProfileEdit.value = "Onbekend";
                            cityInputProfileEdit.value = "Onbekend";
                        }
                    });
            }, 500);
        
        }
        else {
            streetInputProfileEdit.value = "";
            cityInputProfileEdit.value = "";
        }
    }
}

function UpdateRelationData() {
    const profileInfo = JSON.parse(document.getElementById('profileInfo').value);
    profileInfo.first_name = document.getElementById('ckFName').value;
    profileInfo.gender = document.querySelector('input[name=ckGender]:checked').value;
    profileInfo.initials = document.getElementById("ckInitials").value;
    profileInfo.first_name = document.getElementById("ckFName").value;
    profileInfo.birth_name = document.getElementById("ckBName").value;
    profileInfo.date_of_birth = document.getElementById("ckDoBY").value + "-" + pad(document.getElementById("ckDoBM").value) + "-" + pad(document.getElementById("ckDoBD").value);
    profileInfo.telephone_number = document.getElementById("ckTel").value;
    profileInfo.mobilephone_number = document.getElementById("ckMob").value;
    profileInfo.zip_code = document.getElementById("ckZip").value;
    profileInfo.housenumber = document.getElementById("ckHouseNo").value;
    profileInfo.housenumber_addition = document.getElementById("ckHouseNoAdd").value;
    profileInfo.iban = document.getElementById("ckIBAN").value;

    // a seperate object is needed for the partner. This will be saved as interRelation.
    // we do not store the partner name in the profileInfo object anymore, but in the interRelation object because otherwise the full name is displayed in a weird way in mutations.
    const partnerInfoEl = document.getElementById('partnerInfo');
    const partnerInfo = partnerInfoEl ? JSON.parse(partnerInfoEl.value) : {};
    partnerInfo.initials = document.getElementById("ckPInitials").value;
    partnerInfo.birth_name = document.getElementById("ckPBName").value;
    partnerInfo.gender = document.querySelector('input[name=ckPGender]:checked')?.value;
    partnerInfo.zip_code = document.getElementById("ckZip").value;
    partnerInfo.housenumber = document.getElementById("ckHouseNo").value;
    partnerInfo.housenumber_addition = document.getElementById("ckHouseNoAdd").value;
    const partnerDobDay = document.getElementById("ckPDoBD").value;
    const partnerDobMonth = document.getElementById("ckPDoBM").value;
    const partnerDobYear = document.getElementById("ckPDoBY").value;
    const isPartnerDobEmpty = !partnerDobDay && !partnerDobMonth && !partnerDobYear
    if(isPartnerDobEmpty) {
        partnerInfo.date_of_birth = null;
    } else {
        partnerInfo.date_of_birth = document.getElementById("ckPDoBY").value + "-" + pad(document.getElementById("ckPDoBM").value) + "-" + pad(document.getElementById("ckPDoBD").value);
    }    
    
    const requestObject = {
        Relation: profileInfo,
        InterRelation: partnerInfo
    };

    fetch("/umbraco/api/KorenFrontend/UpdateRelationData", {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestObject)
    }).then(response => response.json())
        .then(response => {
            if (response) {
                if (response.success) {
                    window.location.href = location.protocol + '//' + location.host + location.pathname + "?success=true";
                }
                else {
                    const err = encodeURIComponent(response.korenErrorMessage.message);
                    window.location.href = location.protocol + '//' + location.host + location.pathname + "?error=" + err;
                }
            }
        });
}

// Request Username Change
if (document.getElementById('ckChangeEmailAddressForm')) {

    const form = new JustValidate('#ckChangeEmailAddressForm', {
        validateBeforeSubmitting: true
    });
    
    if (form) {
        form
            .addField('#ckNewEmailAddress', [
                {
                    rule: 'email',
                    errorMessage: 'De ingevulde waarde voor het emailadres is incorrect'
                }
            ]).onSuccess(( event ) => {
                RequestUsernameChange();
            });
    }
}

function RequestUsernameChange() {
    const requestObject = {};
    requestObject.Username = document.getElementById('ckNewEmailAddress').value;
    requestObject.Password = document.getElementById('ckPassword').value;

    fetch("/umbraco/api/KorenFrontend/RequestUsernameChange", {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestObject)
    }).then(response => response.json())
    .then(response => {
        if (response && response.success) {
            window.location.href = location.protocol + '//' + location.host + location.pathname + "?success=true";
        }
        else {
            const err = encodeURIComponent(response.korenErrorMessage.message);
            window.location.href = location.protocol + '//' + location.host + location.pathname + "?error=" + err;
        }
    });
}

// ChangePassword
if (document.getElementById('ckPasswordChangeForm')) {

    const form = new JustValidate('#ckPasswordChangeForm', {
        validateBeforeSubmitting: true
    });
    
    if (form) {
        form
            .onSuccess(( event ) => {
                ChangePassword();
            });
    }
}

function ChangePassword() {
    const requestObject = {};
    requestObject.PasswordCurrent = document.getElementById('ckCurrentPassword').value;
    requestObject.PasswordNew = document.getElementById('ckNewPassword').value;

    fetch("/umbraco/api/KorenFrontend/ChangePassword", {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestObject)
    }).then(response => response.json())
        .then(response => {
            if (response && response.success) {
                window.location.href = location.protocol + '//' + location.host + location.pathname + "?success=true";
            }
            else {
                const err = encodeURIComponent(response.korenErrorMessage.message);
                window.location.href = location.protocol + '//' + location.host + location.pathname + "?error=" + err;
            }
    });
}

// Request Phone number Change
if (document.getElementById('ckPhoneForm')) {
    const form = new JustValidate('#ckPhoneForm', {
        validateBeforeSubmitting: true
    });

    if (form) {
        form
        .addField('#ckTel', [
            {
                rule: 'required',
                errorMessage: 'Het telefoonnummer is verplicht'
            },
            {
                rule: 'customRegexp',
                value: '[0-9]',
                errorMessage: 'De ingevulde waarde voor het telefoonnummer is incorrect'
            }
        ]).onSuccess(( event ) => {
            const cancelButton = document.querySelector('[data-action="cancel"]');
            const closeButton = document.querySelector('[data-bs-dismiss="modal"]')
            const submitButton = document.getElementById('submitPhoneNumber');
            const submitButtonText = document.getElementById('btntext');
            const originalSubmitButtonText = submitButtonText?.innerText ?? '';
            const loader = document.getElementById('btnloader');
            const phoneNumber = document.getElementById("ckTel").value;
            if (cancelButton && submitButtonText && loader) {
                closeButton.removeAttribute('data-bs-dismiss') 
                cancelButton.setAttribute('disabled',true);
                submitButton.setAttribute('disabled',true); 
                loader.classList.remove('d-none');
                submitButtonText.innerText = 'Even geduld...';
            }

            RequestPhoneChange().then(result => {
                if(loader) {
                    loader.classList.add('d-none');
                    closeButton.setAttribute('data-bs-dismiss', 'modal')
                    cancelButton.removeAttribute('disabled');
                    submitButton.removeAttribute('disabled');
                    submitButtonText.innerText = originalSubmitButtonText;
                }

                if (result.success) {
                    const successEvent = new CustomEvent('phoneChangeSuccess', {
                        detail: { phoneNumber: phoneNumber }
                    });
                    document.dispatchEvent(successEvent);
                } else {
                    form.showErrors({ '#ckTel': result.error });
                }
            });
        });
    }
}

function RequestPhoneChange() {    
    const profileInfo = JSON.parse(document.getElementById('profileInfo').value);
    const phoneNumber = document.getElementById("ckTel").value;

    // if the number starts with 06, we assume it's a mobile number and set mobilephone_number instead of the telephone_number
    if(phoneNumber.startsWith('06')) {
        profileInfo.mobilephone_number = phoneNumber;
    } else {
        profileInfo.telephone_number = phoneNumber;
    }   

    const requestObject = {
        Relation: profileInfo,
        InterRelation: null
    };

    return fetch("/umbraco/api/KorenFrontend/UpdateRelationData", {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestObject)
    }).then(response => response.json())
        .then(response => {
            if (response && response.success) {
                return { success: true, data: response };
            }

            const errorMessage = response?.korenErrorMessage?.message ? response.korenErrorMessage.message : 'Helaas, er is iets mis gegaan';
            return { success: false, error: errorMessage };            
        })
        .catch(() => {
            return { success: false, error: 'Helaas, er is iets mis gegaan' };
        });
}

// SetLabels
if (document.getElementById('ckSetLabelsForm')) {

    const form = new JustValidate('#ckSetLabelsForm', {
        validateBeforeSubmitting: true
    });
    
    if (form) {
        form
            .onSuccess(( event ) => {
                SetLabels();
            });
    }
}

function SetLabels() {
    const radiobuttons = document.querySelectorAll('input[type="radio"]');
    const checkedRadiobutton = document.querySelector('input[type="radio"]:checked');

    if (radiobuttons && checkedRadiobutton) {
        const requestArray = [];

        for(let i = 0; i < radiobuttons.length - 1; i++) {
            const radiobutton = radiobuttons[i];
            const labelRequest = {};
            labelRequest.Id = radiobutton.value;
            labelRequest.Active = radiobutton.id == checkedRadiobutton.id;
            requestArray.push(labelRequest);
        }
    
        fetch("/umbraco/api/KorenFrontend/SetLabels", {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestArray)
        }).then(response => response.json())
            .then(response => {
                if (response && response.success) {
                    window.location.href = location.protocol + '//' + location.host + location.pathname + "?success=true";
                }
                else {
                    const err = encodeURIComponent(response.korenErrorMessage.message);
                    window.location.href = location.protocol + '//' + location.host + location.pathname + "?error=" + err;
                }
        });
    }
}

// Change payment method. (Disabled per client request. See ticket #5206)
// if (document.getElementById('ckChangePaymentMethodForm') && document.getElementById('submitChangePaymentMethod')) {

//     const form = new JustValidate('#ckChangePaymentMethodForm', {
//         validateBeforeSubmitting: true
//     });

//     if (form) {
//         form
//         .addField('#ckPaymentIban', [
//             {
//                 rule: 'required',
//                 errorMessage: 'Het rekeningnummer is verplicht'
//             },
//             {
//                 validator: () => document.getElementById('ckPaymentIban').value.length <= 18,
//                 errorMessage: 'De lengte van het IBAN nummer is te lang'
//             },
//             {
//                 validator: () => {
//                     const ibanPattern = /^NL[a-zA-Z0-9]{2}\s?([a-zA-Z]{4}\s?){1}([0-9]{4}\s?){2}([0-9]{2})\s?$/;
//                     return ibanPattern.test(document.getElementById('ckPaymentIban').value);
//                 },
//                 errorMessage: 'De ingevulde waarde voor het IBAN nummer is incorrect'
//             }
//         ])
//         .onSuccess(( event ) => {
//             const submitButtonText = document.getElementById('btntext');
//             if (submitButtonText) {
//                 const loader = document.getElementById('btnloader');

//                 if (loader) {
//                     const submitButton = document.getElementById('submitChangePaymentMethod');
//                     submitButton.setAttribute('disabled', true);
//                     loader.classList.remove('d-none');
//                     submitButtonText.innerText = 'Even geduld...';
//                 }
//             }
//             ChangePaymentMethod();
//         });
//     }
// }

// function ChangePaymentMethod() {
//     const requestObject = {
//         iban: document.getElementById('ckPaymentIban').value
//     };

//     fetch("/umbraco/api/KorenFrontend/ChangePaymentMethod", {
//         method: 'post',
//         headers: {
//             'Accept': 'application/json',
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(requestObject)
//     }).then(response => response.json())
//         .then(response => {
//             if (response && response.success) {
//                 window.location.href = location.protocol + '//' + location.host + location.pathname + "?success=true";
//             }
//             else {
//                 const err = encodeURIComponent(response.korenErrorMessage.message);
//                 window.location.href = location.protocol + '//' + location.host + location.pathname + "?error=" + err;
//             }
//         });
// }

// Forgot password
if (document.getElementById('ckForgotPasswordForm')) {

    const form = new JustValidate('#ckForgotPasswordForm', {
        validateBeforeSubmitting: true
    });
    
    if (form) {
        form
        .addField('#ckEmailAddress', [
            {
                rule: 'required',
                errorMessage: 'Het emailadres is verplicht'
            },
            {
                rule: 'email',
                errorMessage: 'De ingevulde waarde voor het emailadres is incorrect'
            }
        ])
            .onSuccess(( event ) => {
                ForgotPassword();
            });
    }
}

function ForgotPassword() {
    const username = document.getElementById('ckEmailAddress').value;

    if (username) {

        fetch("/umbraco/api/KorenFrontend/RequestPasswordResetForUser", {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(username)
        }).then(response => response.json())
            .then(response => {
                if (response && response.success) {
                    window.location.href = location.protocol + '//' + location.host + location.pathname + "?success=true";
                }
                else {
                    const err = encodeURIComponent(response.korenErrorMessage.message);
                    window.location.href = location.protocol + '//' + location.host + location.pathname + "?error=" + err;
                }
        });
    }
}

// Reset password
if (document.getElementById('ckPasswordResetForm')) {

    const form = new JustValidate('#ckPasswordResetForm', {
        validateBeforeSubmitting: true
    });
    
    if (form) {
        form
        .addField('#ckNewPassword', [
            {
                rule: 'required',
                errorMessage: 'Vul een nieuw wachtwoord in'
            },
            {
                rule: 'customRegexp',
                value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{8,}$/,
                errorMessage: 'Het wachtwoord moet minimaal 8 karakters hebben, met minimaal 1 cijfer, 1 hoofdletter en een speciaal karakter (! $ % * ? @).'
            }
        ])
        .addField('#ckNewPasswordCheck', [
            {
                rule: 'required',
                errorMessage: 'Vul nogmaals uw nieuwe wachtwoord in'
            },
            {
                rule: 'customRegexp',
                value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{8,}$/,
                errorMessage: 'Het wachtwoord moet minimaal 8 karakters hebben, met minimaal 1 cijfer, 1 hoofdletter en een speciaal karakter (! $ % * ? @).'
            }
        ]).onSuccess(( event ) => {
                ResetPassword();
            });
    }
}

function ResetPassword() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const password = document.getElementById('ckNewPassword').value;

    if (token) {
        const passwordRequestObject = {};
        passwordRequestObject.Token = token;
        passwordRequestObject.Password = password;

        fetch("/umbraco/api/KorenFrontend/ResetPassword", {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(passwordRequestObject)
        }).then(response => response.json())
            .then(response => {
                if (response && response.success) {
                    window.location.href = location.protocol + '//' + location.host + location.pathname + "?success=true";
                }
                else {
                    const err = encodeURIComponent(response.korenErrorMessage.message);
                    window.location.href = location.protocol + '//' + location.host + location.pathname + "?token=" + token + "&error=" + err;
                }
        });
    }
}

// Login With Card Request
if (document.getElementById('ckLoginWithCardRequest')) {

    const form = new JustValidate('#ckLoginWithCardRequest', {
        validateBeforeSubmitting: true
    });
    
    if (form) {
        const passwordField = document.getElementById('ckPassword');
        const passwordCheckField = document.getElementById('ckPasswordCheck');
    
        if (passwordField && passwordCheckField) {
            passwordField.addEventListener("keydown", (event) => {
                if (event.isComposing || event.keyCode === 229) {
                  return;
                }
                if (passwordField.value != passwordCheckField.value) {
                    form.showErrors({'ckPassword': 'De ingevoerde wachtwoorden komen niet overeen.'})
                }
            });

            passwordCheckField.addEventListener("keydown", (event) => {
                if (event.isComposing || event.keyCode === 229) {
                  return;
                }
                if (passwordField.value != passwordCheckField.value) {
                    form.showErrors({'ckPasswordCheck': 'De ingevoerde wachtwoorden komen niet overeen.'})
                }
            });
        }

        form
        .addField('#ckCardNumber', [
            {
                rule: 'required',
                errorMessage: 'Vul uw CareynPlus-kaart nummer in.'
            }
        ])
        // .addField('#ckBirthday', [
        //     {
        //         rule: 'required',
        //         errorMessage: 'Vul uw geboortedatum in.'
        //     },
        //     {
        //         rule: 'customRegexp',
        //         value: /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-(19|20)\d{2}$/,
        //         errorMessage: 'Vul een geldige geboortedatum in (dd-mm-jjjj).'
        //     }
        // ])
        .addField('#ckZipcode', [
            {
                rule: 'customRegexp',
                value: '^[1-9][0-9]{3}[A-Za-z]{2}$',
                errorMessage: 'Vul uw postcode in zonder spaties, bijvoorbeeld 3100AX. Let op: plaats ook geen spatie vóór de postcode.'
            }
        ])
        .addField('#ckHousenumber', [
            {
                rule: 'customRegexp',
                value: '^[0-9]*$',
                errorMessage: 'Huisnummer zonder toevoeging, enkel het huisnummer is nodig.'
            }
        ])
        .addField('#ckAgreeToPrivacy', [{
            rule: 'required',
            errorMessage: 'U dient akkoord te gaan met de privacyverklaring.'
        }])
        .addField('#ckPassword', [
            {
                rule: 'required',
                errorMessage: 'Vul uw wachtwoord in'
            },
            {
                rule: 'customRegexp',
                value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{8,}$/,
                errorMessage: 'Het wachtwoord moet minimaal 8 karakters hebben, met minimaal 1 cijfer, 1 hoofdletter en een speciaal karakter (! $ % * ? @).'
            }
        ])
        .addField('#ckPasswordCheck', [
            {
                rule: 'required',
                errorMessage: 'Vul nogmaals uw wachtwoord in'
            },
            {
                rule: 'customRegexp',
                value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{8,}$/,
                errorMessage: 'Het wachtwoord moet minimaal 8 karakters hebben, met minimaal 1 cijfer, 1 hoofdletter en een speciaal karakter (! $ % * ? @).'
            }
        ]).onSuccess(( event ) => {
            const submitButtonText = document.getElementById('btntext');
            if (submitButtonText) {
                const loader = document.getElementById('btnloader');

                if (loader){
                    const submitButton = document.getElementById('submitLoginWithCardRequest');
                    submitButton.setAttribute('disabled',true); 
                    loader.classList.remove('d-none');
                    submitButtonText.innerText = 'Even geduld...';
                }
            }
            LoginWithCardRequest();
            });
    }
}

function LoginWithCardRequest() {
    const loginWithCardRequestObject = {};
    loginWithCardRequestObject.accountSearchData = {};
    const accountSearchData = {};

    loginWithCardRequestObject.emailaddress = document.getElementById('ckEmailAddress').value;
    loginWithCardRequestObject.password = document.getElementById('ckPassword').value;
    
    accountSearchData.customer_id = document.getElementById('ckCardNumber').value;
    //accountSearchData.date_of_birth = convertBirthday(document.getElementById('ckBirthday').value)
    accountSearchData.housenumber = document.getElementById('ckHousenumber').value;
    accountSearchData.zip_code = document.getElementById('ckZipcode').value;

    loginWithCardRequestObject.accountSearchData = accountSearchData;

    fetch("/umbraco/api/KorenFrontend/CreateAccountExistingCustomer", {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(loginWithCardRequestObject)
    }).then(response => response.json())
        .then(response => {
            if (response && response.success) {
                window.location.href = location.protocol + '//' + location.host + location.pathname + "?success=true";
            }
            else {
                let err = encodeURIComponent(response.korenErrorMessage.message);                
                // if(response.korenErrorMessage.detail?.accountSearchData?.date_of_birth !== undefined) {
                //     err = encodeURIComponent(response.korenErrorMessage.message + ' De geboortedatum klopt niet. Vul de geboortedatum in van de naam op uw CareynPlus-kaart.');
                // }
                if(response.korenErrorMessage.code === 5001) {
                    err = "5001"
                }

                window.location.href = location.protocol + '//' + location.host + location.pathname + "?error=" + err;
            }
    });
}

// get the birthday input (dd-MM-YYYY) and convert it to yyyy-MM-dd format
// function convertBirthday(dateStr) {
//     const [day, month, year] = dateStr.split("-");
//     return `${year}-${month}-${day}`;
// }

// Zipcode lookup
const streetInput = document.querySelector('.straat input');
const cityInput = document.querySelector('.woonplaats input');
const zipCodeInput = document.querySelector('.postcode input');
const houseNrInput = document.querySelector('.huisnummer input');
const houseNoAddInput = document.querySelector('.huisnummertoevoeging input');
const membercheckHiddenField = document.querySelector('input.memberCheck');
const nextButton = document.querySelector('input.next');

if (document.getElementsByClassName('lidworden').length > 0) {
    if (streetInput && cityInput && houseNoAddInput) {
        onZipCodeChange();
        zipCodeInput.addEventListener("keyup", onZipCodeChange);
        houseNrInput.addEventListener("keyup", onZipCodeChange);
        houseNrInput.addEventListener("change", onZipCodeChange);
        houseNoAddInput.addEventListener("keyup", onZipCodeChange)
    }
}

function onZipCodeChange() {
    const zipCode = zipCodeInput.value;
    const houseNr = houseNrInput.value;
    const houseNoAdd = houseNoAddInput.value;

    if (zipCode && houseNr) {
        if (zipCode.match(new RegExp(/^[1-9][0-9]{3}[A-Za-z]{2}$/))) {
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                checkZipCode(zipCode, houseNr, houseNoAdd);
                memberCheck(zipCode, houseNr, houseNoAdd);
            }, 500);
        
        }
        else {
            streetInput.value = "";
            cityInput.value = "";
            if (membercheckHiddenField) {
                membercheckHiddenField.value = '1';
                membercheckHiddenField.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }
}

function checkZipCode(zipCode, houseNr, houseNoAdd) {
    let url = "/umbraco/api/korenFrontend/ZipCodeLookup"
    const zipcodeArg = "zipcode=" + zipCode;
    const housenumberArg = "housenumber=" + houseNr;
    url += "?" + zipcodeArg + "&" + housenumberArg;
    if (houseNoAdd) {
        url += "&" + "housenumberAddition=" + houseNoAdd;
    }

    fetch(url).then(res =>
        res.json()).then(d => {
            if (d) {
                streetInput.value = d.straatnaam;
                cityInput.value = d.plaatsnaam;
            }
            else {
                streetInput.value = "Onbekend";
                cityInput.value = "Onbekend";
            }
        });
}

function memberCheck(zipCode, houseNr, houseNrAdd) {
    fetch("/umbraco/api/korenFrontend/MemberCheck", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            postalcode: zipCode.trim().toLowerCase(),
            housenumber: parseInt(houseNr, 10) || 0,
            housenumber_addition: houseNrAdd
        })
    }).then(res => {
        if (!res.ok) throw new Error("membercheck failed");
        return res.json();
    }).then(status => {
        if (membercheckHiddenField) {
            membercheckHiddenField.value = status;
            membercheckHiddenField.dispatchEvent(new Event("change", { bubbles: true }));
            if(nextButton) {
                if(status !== "1") {
                    nextButton.setAttribute('disabled', true);
                } else {
                    nextButton.removeAttribute('disabled');
                }
            }
        }
    }).catch(() => {
        if (membercheckHiddenField) {
            membercheckHiddenField.value = "1";
            membercheckHiddenField.dispatchEvent(new Event("change", { bubbles: true }));
        }
    });
}

// Test credentials
let timeout = null;
const emailInput = document.querySelector('.emailadresgebruikersnaamaanmaken input');
const passwordInput = document.querySelector('.wachtwoordaanmaken input');

if (document.getElementsByClassName('lidworden').length > 0) {
    if (emailInput && passwordInput) {
        checkCredentials();
        emailInput.addEventListener("keypress", checkCredentials);
        passwordInput.addEventListener("keypress", checkCredentials);
    }
}

function checkCredentials() {
    const email = emailInput.value;
    const password = passwordInput.value;

    if (email && password) {
        clearTimeout(timeout);
            timeout = setTimeout(function () {

                const credentialModelObject = {};
                credentialModelObject.emailaddress = email;
                credentialModelObject.password = password;

                fetch("/umbraco/api/KorenFrontend/TestCredentialsAcceptable", {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(credentialModelObject)
                }).then(response => response.json())
                    .then(response => {
                        const passwordId = passwordInput.id;
                        const errorSpan = document.querySelector('[data-valmsg-for="' + passwordId + '"]');

                        if (response && response.success) {
                            if (errorSpan) {
                                errorSpan.className = 'field-validation-valid';
                                errorSpan.innerText = '';
                                document.getElementById(passwordId).className = 'text input-validation-valid';
                            }
                        } else if (errorSpan) {
                            const err = encodeURIComponent(response.korenErrorMessage.message);
                            errorSpan.className = 'field-validation-error';
                            errorSpan.innerText = err.replaceAll('%20', ' ');
                            document.getElementById(passwordId).className = 'text input-validation-error';
                            
                        }
                    })
            }, 500);
    }
}

function initLidwordenSubmitLoader() {
    const form = document.querySelector('.lidworden form');
    if (!form) return;

    const submitInput = form.querySelector(
        'input.btn.primary[data-umb="submit-forms-form"]'
    );

    if (!submitInput || submitInput.dataset.loaderInit) return;

    submitInput.dataset.loaderInit = 'true';

    const submitButton = document.createElement('button');
    submitButton.type = 'submit';
    submitButton.className = `${submitInput.className} d-flex align-items-center`;
    submitButton.name = submitInput.name;
    submitButton.value = submitInput.value;

    submitButton.dataset.formNavigate = submitInput.dataset.formNavigate;
    submitButton.dataset.umb = submitInput.dataset.umb;

    const loader = document.createElement('span');
    loader.className = 'me-2 d-none';
    loader.innerHTML = '<span class="btn-loader d-inline-block"></span>';

    const buttonText = document.createElement('span');
    buttonText.textContent = submitInput.value;

    submitButton.append(loader, buttonText);
    submitInput.replaceWith(submitButton);

    const prevButton = form.querySelector(
        'input[data-umb="prev-forms-form"]'
    );

    form.addEventListener('submit', () => {
        if (submitButton.disabled) return;

        submitButton.disabled = true;
        prevButton?.toggleAttribute('disabled', true);

        loader.classList.remove('d-none');
        buttonText.textContent = 'Even geduld...';
    });
}

initLidwordenSubmitLoader();

// Subscribe for newsletter anonymous
if (document.getElementById('ckAutoSubscribeNewsletter')) {

    const form = new JustValidate('#ckAutoSubscribeNewsletter', {
        validateBeforeSubmitting: true
    });
    if (form) {
        form
        .addField('#ckEmailAddress', [
            {
                rule: 'required',
                errorMessage: 'Het emailadres is verplicht'
            },
            {
                rule: 'email',
                errorMessage: 'De ingevulde waarde voor het emailadres is incorrect'
            }
        ])
        .addField('#ckConsent', [
            {
                rule: 'required',
                errorMessage: 'Je moet akkoord gaan met de privacyverklaring'
            }
        ])
            .onSuccess(( event ) => {
                AutoSubscribe();
            });
    }
}

function AutoSubscribe() {
    const submitButtonText = document.getElementById('btntext');
    const loader = document.getElementById('btnloader');

    if (loader){
        const submitButton = document.getElementById('submitAutoSubscription');
        submitButton.setAttribute('disabled',true); 
        loader.classList.remove('d-none');
        submitButtonText.innerText = 'Even geduld...';
    }

    const emailAddress = document.getElementById('ckEmailAddress').value;
    const mailingListId = document.getElementById('ckMailingListId').value;
    const anonymousMailingListId = document.getElementById('ckAnonymousMailingListId').value;

    const subscriptionModelObject = {};
    subscriptionModelObject.emailaddress = emailAddress;
    subscriptionModelObject.mailingListId = mailingListId;
    subscriptionModelObject.anonymousMailingListId = anonymousMailingListId;

    fetch("/umbraco/api/KorenFrontend/AutoSubscribe", {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(subscriptionModelObject)
    }).then(response => response.json())
        .then(response => {
            document.getElementById('ckAutoSubscribeNewsletter').classList.add('d-none');
            if (response && response.success) {
                document.getElementById('autoSubscriptionSucces').classList.remove('d-none');
            }
            else {
                document.getElementById('autoSubscriptionError').classList.remove('d-none');
            }
    });
}


// Subscribe for newsletter for members
if (document.getElementById('ckSubscribeNewsletter')) {

    const form = new JustValidate('#ckSubscribeNewsletter', {
        validateBeforeSubmitting: true
    });
    if (form) {
        form.onSuccess(( event ) => {
            Subscribe();
        });
    }
}

function Subscribe() {
    const submitButtonText = document.getElementById('btntext');
    const loader = document.getElementById('btnloader');
    const submitButton = document.getElementById('submitSubscription');

    if (loader){
        submitButton.setAttribute('disabled',true); 
        loader.classList.remove('d-none');
        submitButtonText.innerText = 'Even geduld...';
    }

    const mailingListId = document.getElementById('ckMailingListId').value;
    const checked = document.getElementById('ckNewsletter').checked;

    const subscriptionModelObject = {};
    subscriptionModelObject.checked = checked;
    subscriptionModelObject.mailingListId = mailingListId;

    fetch("/umbraco/api/KorenFrontend/Subscribe", {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(subscriptionModelObject)
    }).then(response => response.json())
        .then(response => {
            loader.classList.add('d-none');
            submitButton.setAttribute('disabled',false); 
            submitButtonText.innerText = 'Wijzigen';
            if (response && response.success) {
                document.getElementById('subscriptionSucces').classList.remove('d-none');
            }
            else {
                document.getElementById('subscriptionError').classList.remove('d-none');
            }
    });
}

function showPassword() {
    document.querySelectorAll('[data-show-password]').forEach((button) => {
        const wrapper = button.closest('.umbraco-forms-field-wrapper');
        const input = wrapper?.querySelector('[data-password-input]');
        if (!input) return;

        const label = button.querySelector('.visually-hidden');

        button.addEventListener('click', () => {
            const isVisible = button.classList.toggle('show-password');
            input.type = isVisible ? 'text' : 'password';

            if (label) {
                label.textContent = isVisible ? 'Verberg wachtwoord' : 'Toon wachtwoord';
            }
        });
    });
}

showPassword();